<template>
    <div>
        <vx-card title="Leave Benefits" subtitle="Lists of Leave Benefits"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewLeaveBenefits()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeLeaveBenefits">
                    <template slot="thead">
                        <vs-th>Leave Type</vs-th>
                        <!-- <vs-th>Days</vs-th>
                        <vs-th>Hours</vs-th>
                        <vs-th>Start Date</vs-th>
                        <vs-th>End Date</vs-th>
                        <vs-th>For Year</vs-th> -->
                        <vs-th>Active?</vs-th>
                        <!-- <vs-th>Accrued?</vs-th> -->
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].leaveTypeId">
                                {{ leaveTypeName(data[indextr].leaveTypeId).leaveTypeName }}
                            </vs-td>
                            <!-- <vs-td :data="data[indextr].leaveDays">
                                {{ data[indextr].leaveDays }}
                            </vs-td>
                            <vs-td :data="data[indextr].leaveHours">
                                {{ data[indextr].leaveHours }}
                            </vs-td>
                            <vs-td :data="data[indextr].startDate">
                                {{data[indextr].startDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].endDate">
                                {{data[indextr].endDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].forYear">
                                {{data[indextr].forYear}}
                            </vs-td> -->
                            <vs-td :data="data[indextr].isActive">
                                <vs-checkbox v-model="data[indextr].isActive"/> 
                            </vs-td>
                            <!-- <vs-td :data="data[indextr].isAccrued">
                                <vs-checkbox v-model="data[indextr].isAccrued"/> 
                            </vs-td> -->
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD LEAVE BENEFITS -->
            <vs-prompt
                class="email-compose"
                title="Leave Benefits"
                accept-text= "Submit"
                @accept="onAddLeaveBenefits"
                :is-valid="validForm"
                :active.sync="activePromptNewLeaveBenefits">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                        <v-select name="leaveType-name" class="w-full" v-model="leaveType" label="leaveTypeName" :options="getAllLeaveTypeLookup" placeholder="Please Select" />

                    </div>
                </div>
                <!-- <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Days</span><span style="color:red">*</span>
                        <vs-input name="leave days" v-validate="'numeric|max_value:' + leaveType.maxDays" class="w-full" v-model="leaveDays" :disabled="leaveType.leaveTypeId != null ? false : true" />
                        <span class="text-danger text-sm" v-show="errors.has('leave days')">{{ errors.first('leave days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Hours</span><span style="color:red">*</span>
                        <vs-input name="leave hours" v-validate="'numeric|max_value:' + leaveType.maxDays * 8" class="w-full" v-model="leaveHours" :disabled="leaveType.leaveTypeId != null ? false : true"   />
                        <span class="text-danger text-sm" v-show="errors.has('leave hours')">{{ errors.first('leave hours') }}</span>

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span> <span style="color:red">*</span>
                       <flat-pickr :config="configFromdateTimePicker" :format="format" name="startDate-name" class="w-full" v-model="startDate" placeholder="Select Date" @on-change="onFromChange" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <flat-pickr :config="configTodateTimePicker" :format="format" name="endDate-name" class="w-full" v-model="endDate" placeholder="Select Date" @on-change="onToChange"  />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">For Year</span><span style="color:red">*</span>
                        <v-select   class="w-full" name="year" v-model="forYear" label="year" :options="getYearsLookup" placeholder="2021" />
                   </div>
                </div> -->
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox name="isActive-name" class="w-full" v-model="isActive">Active?</vs-checkbox>
                    </div>
                    <!-- <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox name="isAccrued-name" class="w-full" v-model="isAccrued">Accrued?</vs-checkbox>
                    </div> -->
                </div>
              
                 
               

            
                </vx-card>
            </vs-prompt>




            <!-- EDIT LEAVE BENEFITS -->
            <vs-prompt
                class="email-compose"
                title="Edit Leave Benefits"
                accept-text= "Submit"
                @accept="onEditLeaveBenefits"
                :is-valid="validForm"
                :active.sync="activePromptEditLeaveBenefits">
                <vx-card title="You may update the following information">


               <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Type</span><span style="color:red">*</span>
                        <v-select name="leaveType-name" class="w-full" v-model="leaveType" label="leaveTypeName" :options="getAllLeaveTypeLookup" placeholder="Please Select" />

                    </div>
                </div>
               <!-- <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Days</span><span style="color:red">*</span>
                        <vs-input name="leave days" v-validate="'numeric|max_value:' + leaveType.maxDays" class="w-full" v-model="leaveDays" :disabled="leaveType.leaveTypeId != null ? false : true" />
                        <span class="text-danger text-sm" v-show="errors.has('leave days')">{{ errors.first('leave days') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Leave Hours</span><span style="color:red">*</span>
                        <vs-input name="leave hours" v-validate="'numeric|max_value:' + leaveType.maxDays * 8" class="w-full" v-model="leaveHours" :disabled="leaveType.leaveTypeId != null ? false : true"    />
                        <span class="text-danger text-sm" v-show="errors.has('leave hours')">{{ errors.first('leave hours') }}</span>

                    </div>
                </div>
                
                 <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">From</span> <span style="color:red">*</span>
                       <flat-pickr :config="configFromdateTimePicker" name="startDate-name" class="w-full" v-model="startDate" placeholder="Select Date" @on-change="onFromChange" />
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">To</span>
                        <flat-pickr :config="configTodateTimePicker" name="endDate-name" class="w-full" v-model="endDate" placeholder="Select Date" @on-change="onToChange"  />
                        
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">For Year</span><span style="color:red">*</span>
                        <v-select   class="w-full" name="year" v-model="forYear" label="year" :options="getYearsLookup" placeholder="2021" />
                   </div>
                </div> -->
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox name="isActive-name" class="w-full" v-model="isActive">Active?</vs-checkbox>
                    </div>
                    <!-- <div class="vx-col sm:w-1/2 w-full mb-4">
                        <vs-checkbox name="isAccrued-name" class="w-full" v-model="isAccrued">Accrued?</vs-checkbox>
                    </div> -->
                </div>
                 
                 
            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            leaveType           : [],
            leaveHours          : 0,
            leaveDays           : 0,
            startDate           : new Date(),
            endDate             : null,
            forYear             : null,
            isActive            : true,
            isAccrued           : false,
            userId              : null,

            configFromdateTimePicker: {
              maxDate: null
            },
            configTodateTimePicker: {
              minDate: null
            },

            uid                 : null,
            activePromptNewLeaveBenefits    : false,
            activePromptEditLeaveBenefits    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            this.$store.dispatch('lookup/getAllLeaveTypeLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeLeaveBenefits = this.uid
            
    },
    computed: {
        employeeLeaveBenefits: {
           
           get() { return this.$store.state.hrms.employeeLeaveBenefits },
           set(value) { this.$store.dispatch('hrms/getAllLeaveBenefits',  value )}
            
        },
        getYearsLookup () {
            const year = new Date().getFullYear()
            return Array.from({length: year - 1900}, (value, index) => 1901 + index)
        },
        validForm(){
            return this.leaveType.leaveTypeId != null
        },
        getAllLeaveTypeLookup(){
            return this.$store.state.lookup.getAllLeaveTypes
        },
        leaveTypeName(){
            return (id) => this.$store.getters['lookup/leaveTypeLookup'](id)
        }
       
       
    },
    methods: {
        promptAddNewLeaveBenefits() {
            this.activePromptNewLeaveBenefits = true
        },
        onAddLeaveBenefits() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    leaveTypeId         : this.leaveType.leaveTypeId,
                    // leaveDays           : this.leaveDays,
                    // leaveHours          : this.leaveHours,
                    // startDate           : this.startDate,
                    // endDate             : this.endDate,
                    // forYear             : this.forYear,
                    isActive            : this.isActive,
                    // isAccrued           : this.isAccrued,
                    userId              : this.uid,
                    currentUserId       : this.$store.state.AppActiveUser.uid
                }
                //console.log('leve benefits')
                //console.log(data)
                this.$store.dispatch('hrms/AddLeaveBenefits', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Leave Benefits Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        onEditLeaveBenefits() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    leaveTypeId         : this.leaveType.leaveTypeId,
                    // leaveDays           : this.leaveDays,
                    // leaveHours          : this.leaveHours,
                    // startDate           : this.startDate,
                    // endDate             : this.endDate,
                    // forYear             : this.forYear,
                    isActive            : this.isActive,
                    // isAccrued           : this.isAccrued,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateLeaveBenefits', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Leave Benefits Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
                // form have errors
                this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeLeaveBenefits'](Id)
            this.id                = e.id,
            this.leaveType         = this.leaveTypeName(e.leaveTypeId),
            // this.leaveDays         = e.leaveDays,
            // this.leaveHours        = e.leaveHours,
            // this.startDate         = e.startDate,
            // this.endDate           = e.endDate,
            // this.forYear           = e.forYear,
            this.isActive          = e.isActive,
            // this.isAccrued         = e.isAccrued,
            this.userId            = e.userId

            this.activePromptEditLeaveBenefits = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteLeaveBenefits', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeLeaveBenefits = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Leave Benefits Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        },
        onFromChange(selectedDates, dateStr, instance) {
            this.$set(this.configTodateTimePicker, 'minDate', dateStr);
        },
        onToChange(selectedDates, dateStr, instance) {
            this.$set(this.configFromdateTimePicker, 'maxDate', dateStr);
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>